import React from 'react';
import { SVGProps } from '../../helpers/types';

const AlertInfo: React.FC<SVGProps> = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.33333 5.00001H7.66667V3.66668H6.33333M7 12.3333C4.06 12.3333 1.66667 9.94001 1.66667 7.00001C1.66667 4.06001 4.06 1.66668 7 1.66668C9.94 1.66668 12.3333 4.06001 12.3333 7.00001C12.3333 9.94001 9.94 12.3333 7 12.3333ZM7 0.333344C6.12452 0.333344 5.25761 0.505782 4.44878 0.840813C3.63994 1.17584 2.90501 1.66691 2.28595 2.28596C1.03571 3.53621 0.333333 5.2319 0.333333 7.00001C0.333333 8.76812 1.03571 10.4638 2.28595 11.7141C2.90501 12.3331 3.63994 12.8242 4.44878 13.1592C5.25761 13.4942 6.12452 13.6667 7 13.6667C8.76811 13.6667 10.4638 12.9643 11.714 11.7141C12.9643 10.4638 13.6667 8.76812 13.6667 7.00001C13.6667 6.12453 13.4942 5.25762 13.1592 4.44879C12.8242 3.63995 12.3331 2.90502 11.714 2.28596C11.095 1.66691 10.3601 1.17584 9.55122 0.840813C8.74239 0.505782 7.87548 0.333344 7 0.333344ZM6.33333 10.3333H7.66667V6.33334H6.33333V10.3333Z"
        fill="#3A49E3"
      />
    </svg>
  );
};

export default AlertInfo;
